<template>
  <div id="pageTitle-compos" class="white-bg">
    <div class="wrapper ht-1500">
      <div class="page-title-item">
        <el-row :class="screenWidth>768?'mb-200':'pl-20 pr-20'">
          <el-col :span="12" :xs="24" class="mt-50">
            <div ref="pageSubTitle" class="tt-u mb-20 pr transition-gentle bm--40 op-0 danger" style="letter-spacing: 8px;">{{subtitle}}</div>
            <div ref="pageTitle" class="pagetitle-title serif pr transition-gentle bm--80 op-0 fw-600 pl-30 wi-600 pr-30">{{title}}</div>
          </el-col>
          <el-col :span="12" :xs="24">
            <!-- 服务模块的svg尺寸和其他不一样 -->
            <div :class="screenWidth>768?'bm-60':'bm-30'" class="pr op-0 ht-450 of-h transition-gentle" ref="pageSvg">
              <fo-workSvg v-if="type==='works'"></fo-workSvg>
              <fo-postsSvg v-if="type==='posts'"></fo-postsSvg>
              <fo-contactSvg v-if="type==='contact'"></fo-contactSvg>
              <fo-serviceSvg v-if="type==='service'"></fo-serviceSvg>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'pageTitle',
  props: [
    'type',
    'title',
    'subtitle'
  ],
  computed: {
    ...mapGetters([
      'screenHeight',
      'screenWidth'
    ])
  },
  mounted () {
    setTimeout(() => {
      this.$refs.pageTitle.style.opacity = 1
      this.$refs.pageTitle.style.bottom = 0
      this.$refs.pageSubTitle.style.opacity = 1
      this.$refs.pageSubTitle.style.bottom = 0
      this.$refs.pageSvg.style.opacity = 1
      this.$refs.pageSvg.style.bottom = 0
    }, 500)
  }
}
</script>
<style>
.pagetitle-title {
  font-size: 3em;
  width: auto;
}
.page-title-item {
  padding-top: 80px;
}
@media screen and (min-width: 768px) and (max-width: 992px) {
  .pagetitle-title {
    font-size: 60px;
  }
  .page-title-item {
    padding-top: 220px;
  }
}
@media screen and (min-width: 992px) and (max-width: 1200px) {
  .pagetitle-title {
    font-size: 65px;
  }
  .page-title-item {
    padding-top: 220px;
  }
}
@media screen and (min-width: 1200px) and (max-width: 1920px) {
  .pagetitle-title {
    font-size: 70px;
  }
  .page-title-item {
    padding-top: 220px;
  }
}
@media screen and (min-width: 1920px) {
  .pagetitle-title {
    font-size: 74px;
  }
  .page-title-item {
    padding-top: 220px;
  }
}
</style>



// WEBPACK FOOTER //
// src/compos/pageTitle.vue